/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Contract_Overage_HintInputs */



/**
* | output |
* | --- |
* | "When the prepaid budget is used up, usage continues and is metered like the Team plan. It is not invoiced automatically — it appears on the monthly review re..." |
*
* @param {Partner_Contract_Overage_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_contract_overage_hint = /** @type {((inputs?: Partner_Contract_Overage_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Contract_Overage_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ist das vorausbezahlte Budget verbraucht, läuft die Nutzung weiter und wird wie im Team-Tarif gemessen. Sie wird nicht automatisch berechnet — sie erscheint im monatlichen Prüfbericht und wird separat abgerechnet. Aus: Anfragen in der App weichen auf das kostenlose Modell aus, Anfragen über einen API-Schlüssel oder den Microsoft-Teams-Bot werden abgelehnt.")
	return /** @type {LocalizedString} */ ("When the prepaid budget is used up, usage continues and is metered like the Team plan. It is not invoiced automatically — it appears on the monthly review report to be charged separately. Off, requests in the app fall back to the free model and requests through an API key or the Microsoft Teams bot are refused.")
});